import React, { FC, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Spinner } from 'src/components/spinner';
import { NavigationService } from 'src/services/navigation-service';
import { fetchTokenActionCreator } from 'src/state/auth/action-creators/fetch-token-action-creator';
import { selectIsAuthenticating } from 'src/state/auth/selectors';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';

export const PageAuthCallback: FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const authorizing = useAppSelector(selectIsAuthenticating);

  const locationSearchParams = new URLSearchParams(location.search);
  const code = locationSearchParams.get('code');
  const state = locationSearchParams.get('state');

  useEffect(() => {
    dispatch(fetchTokenActionCreator({ code, state }));
  }, [code, state, dispatch]);

  if (authorizing) {
    return <Spinner />;
  }

  return <Navigate to={NavigationService.CHOOSE_ACCOUNT} replace={true} />;
};
